// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputText_inputContainer__ujf5q","inputTitle":"InputText_inputTitle__OJrXf","inputField":"InputText_inputField__HXze0"};